import React, { useState, useLayoutEffect } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import EmployeeService from '@/services/Employee.service';
import { useSnackbar } from 'notistack';
import Employee from '@/types/Employee.type';
import { Departments } from '@/types/Department.type';
import { Messages } from '@/common/constants';
import { Box, Grid } from '@mui/material';
import PageTitle from '@/components/common/PageTitle';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import Loading from '@/components/common/Loading';
import URL from '@/common/routes/Url';
import EmployeeTableBody from '@/components/employee/EmployeeTableBody';
import CommonTableContainer from '@/components/common/CommonTableContainer';

interface DelType {
  id: number;
  name: string;
}

const EmployeeList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [employees, setEmployees] = useState<Array<Employee & Departments>>([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [delEmployee, setDelEmployee] = useState<DelType>({ id: 0, name: '' });

  const getEmployees = () => {
    EmployeeService.getAll()
      .then((response) => {
        setEmployees(response.data);
        setLoading(false);
      })
      .catch((e) => {
        enqueueSnackbar(Messages.select.failure);
      });
  };

  useLayoutEffect(() => {
    getEmployees();
  }, []);

  const editEmployee = (id: number) => {
    navigate(`${URL.employees}/${id}`);
  };

  const deleteEmployee = async (id: number) => {
    try {
      await EmployeeService.delete(id);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
    enqueueSnackbar(Messages.delete.success, { variant: 'info' });
    getEmployees();
  };

  const handleDialog = (id: number, name: string) => {
    setDelEmployee({
      id: id,
      name: name,
    });
    setOpen(true);
  };

  const employeeTableHeads = ['社員名', 'メールアドレス', '部署名', '権限', ''];
  const employeeTableBody = <EmployeeTableBody onEdit={editEmployee} onDelete={handleDialog} rows={employees} />;

  if (loading) {
    return <Loading />;
  }
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Box sx= {{ display: { xs: 'block', sm: 'none' } }}>
          <PageTitle>社員マスタ</PageTitle>
        </Box>
        <Box sx={{ marginBottom: '8px' }}>
          <Button variant="contained" color="primary" onClick={() => navigate(`${URL.employees}/add`)}>
            追加画面へ
          </Button>
        </Box>
        <CommonTableContainer tableHeads={employeeTableHeads} tableBody={employeeTableBody} />
        <ConfirmDialog
          open={open}
          onClose={() => setOpen(false)}
          onOk={() => {
            setOpen(false);
            deleteEmployee(delEmployee.id);
          }}
        >
          {delEmployee.name}を本当に削除しますか？
        </ConfirmDialog>
      </Grid>
    </Grid>
  );
};
export default EmployeeList;
